// external libs
import { combineEpics } from 'redux-observable'

// epics
import GetOperatingHoursEpic from './GetOperatingHoursEpic'
import CrmCallbackEpic from './CrmCallbackEpic'
import SettingsEpic from './SettingsEpic'

const epics = [
  GetOperatingHoursEpic,
  CrmCallbackEpic,
	SettingsEpic
]

const rootEpic = combineEpics(...epics)

export default rootEpic
